export enum CategoryTypeEnum {
  CALENDAR_EVENT = "CALENDAR_EVENT",
  SUBJECT_NOTE = "SUBJECT_NOTE",
}
